import Agent from "infrastructure/agent";

/**
 * Field
 */
const getFields = () => Agent.get(`/data/field`);

const createField = field => Agent.post(`/data/field`, field);

const getField = fieldId => Agent.get(`/data/field/${fieldId}`);

const updateField = (fieldId, field) =>
  Agent.put(`/data/field/${fieldId}`, field);
const deleteField = fieldId => Agent.delete(`/data/field/${fieldId}`);

/**
 * Facility
 */
const getFacilities = () => Agent.get(`/data/facility`);

const getFacilitiesForField = fieldId =>
  Agent.get(`/data/field/${fieldId}/facility`);

const createFacility = (fieldId, facility) =>
  Agent.post(`/data/field/${fieldId}/facility`, facility);

const getFacility = (fieldId, facilityId) =>
  Agent.get(`/data/field/${fieldId}/facility/${facilityId}`);

const updateFacility = (fieldId, facilityId, facility) =>
  Agent.put(`/data/field/${fieldId}/facility/${facilityId}`, facility);
const deleteFacility = (fieldId, facilityId) =>
  Agent.delete(`/data/field/${fieldId}/facility/${facilityId}`);

/**
 * Mobile Facility
 */
const getMobileFacilities = () => Agent.get(`/data/mobilefacility`);

const createMobileFacility = mobilefacility =>
  Agent.post(`/data/mobilefacility`, mobilefacility);

const getMobileFacility = mobileFacilityId =>
  Agent.get(`/data/mobilefacility/${mobileFacilityId}`);

const updateMobileFacility = (mobileFacilityId, mobileFacility) =>
  Agent.put(`/data/mobilefacility/${mobileFacilityId}`, mobileFacility);
const deleteMobileFacility = mobileFacilityId =>
  Agent.delete(`/data/mobilefacility/${mobileFacilityId}`);

/**
 * Qualification
 */
const getQualifications = () => Agent.get(`/data/qualification`);

const getQualification = qualificationId =>
  Agent.get(`/data/qualification/${qualificationId}`);

const createQualification = qualification =>
  Agent.post(`/data/qualification`, qualification);

const updateQualification = (qualificationId, qualification) =>
  Agent.put(`/data/qualification/${qualificationId}`, qualification);

const deleteQualification = qualificationId =>
  Agent.delete(`/data/qualification/${qualificationId}`);

/**
 * Crew
 */
const getCrews = () => Agent.get(`/data/crew`);

const getCrew = crewId => Agent.get(`/data/crew/${crewId}`);

const createCrew = crew => Agent.post(`/data/crew`, crew);

const updateCrew = (crewId, crew) => Agent.put(`/data/crew/${crewId}`, crew);

const deleteCrew = crewId => Agent.delete(`/data/crew/${crewId}`);

/**
 * Country
 */
const getCountries = () => Agent.get(`/data/country`);

/**
 * Company
 */
const createCompany = company => Agent.post(`/data/company`, company);

const getCompany = companyId => Agent.get(`/data/company/${companyId}`);

const deleteCompany = companyId => Agent.delete(`/data/company/${companyId}`);

const getCompanies = () => Agent.get(`/data/company`);

const updateCompany = (companyId, company) =>
  Agent.put(`/data/company/${companyId}`, company);

/**
 * Employee Group
 */
const getEmployeeGroups = () => Agent.get(`/data/employeegroup`);

const createEmployeeGroup = employeeGroup =>
  Agent.post(`/data/employeegroup`, employeeGroup);

const updateEmployeeGroup = (id, employeeGroup) =>
  Agent.put(`/data/employeegroup/${id}`, employeeGroup);

const deleteEmployeeGroup = id => Agent.delete(`/data/employeegroup/${id}`);

/**
 * Sub Contractor
 */
const getSubContractors = () => Agent.get(`/data/subcontractor`);

const getSubContractor = employeeId =>
  Agent.get(`/data/subcontractor/${employeeId}`);

const deleteSubContractor = employeeId =>
  Agent.delete(`/data/subcontractor/${employeeId}`);

const createSubContractor = subContractor =>
  Agent.post(`/data/subcontractor`, subContractor);

const updateSubContractor = (employeeId, subContractor) =>
  Agent.put(`/data/subcontractor/${employeeId}`, subContractor);

export default {
  getFields,
  createField,
  getField,
  updateField,
  deleteField,
  getFacilitiesForField,
  createFacility,
  getFacility,
  updateFacility,
  deleteFacility,
  getMobileFacilities,
  createMobileFacility,
  getMobileFacility,
  updateMobileFacility,
  deleteMobileFacility,
  getFacilities,
  getQualifications,
  getQualification,
  createQualification,
  updateQualification,
  deleteQualification,
  getCrews,
  getCrew,
  createCrew,
  updateCrew,
  deleteCrew,
  getCountries,
  createCompany,
  deleteCompany,
  getCompanies,
  updateCompany,
  getEmployeeGroups,
  createEmployeeGroup,
  updateEmployeeGroup,
  deleteEmployeeGroup,
  getSubContractors,
  deleteSubContractor,
  createSubContractor,
  updateSubContractor,
  getSubContractor,
  getCompany,
};
